export default {
  image_url: process.env.VUE_APP_IMG,
  store_url: process.env.VUE_APP_STORE_URL,
  bio_url: process.env.VUE_APP_BIO_URL
}
